<template>
  <!-- NEW ADMIN -->
  <v-card class="pb-0">
    <v-form 
      ref="newInscForm"
      @submit.prevent
    >
      <v-card-title class="deep-purple lighten-2">
        Habilite um novo usuário
      </v-card-title>
      <v-card-text class="pt-8">
        <v-text-field
          v-model="newInscEmail"
          id="newinsc-email"
          label="Email"
          outlined
          type="email"
          hint="ex.: email@exemplo.com"
          persistent-hint
          hide-details="auto"
          :rules="[requiredRule, emailRule]"
          append-icon="mdi-account-plus ml-2 pa-2 full-round-corner"
          @click:append="addToUsuarios('cc3')"
          @blur.stop="$refs.newInscForm.resetValidation()"
        ></v-text-field>
        <!-- <v-row v-if="this.getFeedback.show" class="text-center">
          <v-col cols="12" :class="getFeedback.textColor">
            {{getFeedback.message}}
          </v-col>
        </v-row> -->
      </v-card-text>
    </v-form>
    <v-row>
      <v-col>
        <v-btn color="red" @click="addBatchUsers('cc3')">Adicionar usuário em lote</v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import db from '@/firebase/init'
import { mapMutations, mapGetters } from 'vuex'
import inscritos from '@/assets/inscritos.js'
import moment from 'moment'

export default {
  name: 'NewInsc',
  data() {
    return {
      newInscEmail: null,
      requiredRule: v => !!v || 'Este campo é obrigatório',
      emailRule: v => /.+@.+\..+/.test(v) || 'Email deve ser válido',
    }
  },
  computed: {
    ...mapGetters([ 'getFeedback'])
  },
  mounted() {
  },
  methods: {
    ...mapMutations([ 'setFeedback' ]),


    //Checa se existe na tabela 'cursoID' (cc3, cc4, etc) 'usuarios' 
    addToUsuarios(cursoID){
      if(this.$refs.newInscForm.validate()){
        // console.log(this.$refs.newInscForm.validate())
        const email = this.newInscEmail.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
        // console.log(email)
        // db.collection('cc22')

        // Cria um timestamp 1 ano no futuro para usar como data de validade do curso. utilizado na função abaixo
        const dt = new Date()
        var year = dt.getFullYear()
        var month = dt.getMonth()
        var day = dt.getDate()
        var expiresOn = new Date(year + 1, month, day)
        
        console.log(cursoID.toString())
        db.collection(cursoID.toString())
          .doc(email)
          .get()
          .then((doc) => {
            const data = doc.data()
            console.log(data)
            console.log(doc.exists)
            
            if(doc.exists){
              console.log(doc.exists)
              console.log(data)
              data.cursos = {}
              data.cursos[cursoID] = expiresOn.getTime()
              console.log(data.cursos)
              
              this.checkUsuario(email).then((res) => {
                console.log(res)
                if(res){
                  console.log('usuario já existe')
                  db.collection('usuarios')
                    .doc(email)
                    .set({ cursos: {
                      [cursoID]: expiresOn.getTime()
                      }
                    }, { merge: true })
                    .then(() => {
                      console.log('adicionou a coleção "usuarios" com sucesso. O usuário terá acesso até: ', expiresOn)
                      this.addNewInsc(email, true)
                    })
                    .catch((e) => console.error('erro ao adicionar a tabela "usuarios": ', e.message))
                } else {
                  console.log('usuario não existe')
                  db.collection('usuarios')
                    .doc(email)
                    .set(data)
                    .then(() => {
                      console.log('adicionou a coleção "usuarios" com sucesso')
                      this.addNewInsc(email, false)
                    })
                    .catch((e) => console.error('erro ao adicionar a tabela "usuarios": ', e.message))
                }
              })
              
            } else {
              this.setFeedback({
                show: true,
                message: 'Este email não consta na pré-inscrição',
                btnTxt: 'OK',
                color: 'red',
                textColor: 'white--text',
              })
            }
          })
          .catch((e) => console.error(`erro ao buscar usuario na tabela "${cursoID}"": ${e.message}`))
          // .catch((e) => console.error('erro ao buscar usuario no cc22: ', e.message))
      } else {
        console.log('Preencha o campo e-mail corretamente')
        this.setFeedback({
          show: true,
          message: 'Preencha o campo email corretamente',
          btnTxt: 'OK',
          color: 'amber',
          textColor: 'black--text',
        })
      }
    },
    async addNewInsc(passedEmail, checked){
      const email = passedEmail.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
      // console.log('oi')
      await db.collection('pre-insc4')
        .doc(email)
        .set({
          email: email,
          checked: checked
        })
        .then(() => {
          console.log(email + ' foi adicionado aos pre-inscritos')
          // this.addToUsuarios(email)
          this.setFeedback({
            show: true,
            message: 'Usuário adicionado com sucesso',
            btnTxt: 'OK',
            color: 'green',
            textColor: 'white--text',
          })
          // this.newInscEmail = null
          this.$refs.newInscForm.reset()
        })
      
    },
    async checkUsuario(email) {
      const response = await db.collection('usuarios')
        .doc(email)
        .get()
        .then((doc) => {
          if(doc.exists) {
            return true
          } else {
            return false
          }
        })
        .catch((e) => console.error('erro ao verificar se usuario já existe: ', e.message))
      
      return response
    },

    addBatchUsers(cursoID) {
      // console.log('oi')
      inscritos.forEach(inscrito => {
        console.log(inscrito);
        const sanitizedEmail = inscrito.email.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim()
        
        this.checkPreInsc(sanitizedEmail, cursoID).then((res) => {
          if(res){
            console.log('usuario já existe: ' + inscrito.email)
            console.log(`adiciona "cursos.${cursoID}" como expiresOn.getTime() na tabela "usuarios"`)
            
            this.addToUsuariosAlt(inscrito.email, cursoID)
          } else {
            console.log(`usuario não existe na tabela "${cursoID}":  + ${inscrito.email}`)

            const name = inscrito.name.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
            const lastname = inscrito.lastname.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
            const email = inscrito.email.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
            const especialidade = inscrito.especialidade.replace(/(<([^>]+)>)/gi, "").toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).trim();
            const fullName = `${name} ${lastname}`;
            const tsCadastro = Date.now();
            const dtCadastro = moment().format('YYYY-MM-DD');

            const payload = {
              name, 
              lastname, 
              fullName, 
              email, 
              especialidade, 
              tsCadastro, 
              dtCadastro, 
            }

            db.collection(cursoID)
              .doc(email)
              .set(payload)
              .then(() => {
                console.log(`${inscrito.email}  foi adicionado a coleção "${cursoID}" com sucesso`)
                this.addToUsuariosAlt(inscrito.email, cursoID)
              })
              .catch((e) => console.error('erro ao adicionar a tabela "usuarios": ', e.message))
          }
        })
      });
    },
    
    async checkCC3(email) {
      const response = await db.collection('cc3')
        .doc(email)
        .get()
        .then((doc) => {
          if(doc.exists) {
            return true
          } else {
            return false
          }
        })
        .catch((e) => console.error('erro ao verificar se usuario já existe: ', e.message))
      
      return response
    },
    async checkPreInsc(email, table) {
      const response = await db.collection(table)
        .doc(email)
        .get()
        .then((doc) => {
          if(doc.exists) {
            return true
          } else {
            return false
          }
        })
        .catch((e) => console.error('erro ao verificar se usuario já existe: ', e.message))
      
      return response
    },
    addToUsuariosAlt(emailProvided, cursoID){
      const email = emailProvided.replace(/(<([^>]+)>)/gi, "").toLowerCase().trim();
      // console.log(email)

      // Cria um timestamp 1 ano no futuro para usar como data de validade do curso. utilizado na função abaixo
      const dt = new Date()
      var year = dt.getFullYear()
      var month = dt.getMonth()
      var day = dt.getDate()
      var expiresOn = new Date(year + 1, month, day)

      db.collection(cursoID)
        .doc(email)
        .get()
        .then((doc) => {
          const data = doc.data()
          if(doc.exists){
            data.cursos = {}
            data.cursos[cursoID] = expiresOn.getTime()
            // console.log(data)

            this.checkUsuario(email).then((res) => {
              if(res){
                console.log(email + ' usuario já existe')
                db.collection('usuarios')
                  .doc(email)
                  .set({ cursos: {
                      [cursoID]: expiresOn.getTime()
                      }
                    }, { merge: true })
                  .then(() => {
                    console.log('adicionou a coleção "usuarios" com sucesso. O usuário terá acesso até: ', expiresOn)
                    this.addNewInsc(email, true)
                  })
                  .catch((e) => console.error(email + ': erro ao adicionar a tabela "usuarios": ', e.message))
              } else {
                console.log('usuario não existe na tabela "usuários": ' + email)
                db.collection('usuarios')
                  .doc(email)
                  .set(data)
                  .then(() => {
                    console.log(email + ' foi adicionado a coleção "usuarios" com sucesso')
                    this.addNewInsc(email, false)
                  })
                  .catch((e) => console.error('erro ao adicionar a tabela "usuarios": ', e.message))
              }
            })
            
          } else {
            this.setFeedback({
              show: true,
              message: 'Este email não consta na pré-inscrição',
              btnTxt: 'OK',
              color: 'red',
              textColor: 'white--text',
            })
          }
        })
        .catch((e) => console.error(`erro ao buscar usuario na tabela "${cursoID}": ${e.message}`))
        // .catch((e) => console.error('erro ao buscar usuario no cc22: ', e.message))
    },
  }
}
</script>